import React, { PureComponent } from 'react';
import  DBKText from '@dbk/ui-text';
import { View, TouchableOpacity, Text  } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import Button from '@dbk/ui-buttons';
import InfoMessage from '../../../components/info-message/index.js';
import {
  ValidationInput,
  ValidationLabel,
} from '../../../components/common/validation/index.js';
import {
  emptyError,
  noMatchError,
  minimumCharsError,
  upperCaseError,
  lowerCaseError,
  equalPassword,
  specialCharsError,
} from '../../../components/common/validation/validation-utils.js';
import styles from '../change-password.styles.js';
import encryptionHtmlAndScript from '../../user/dbsecurelogin/webviewencryptioninjectscript.js';
import { H3 } from '@dbk/ui-text';
import { TextInput, FormGroup, Label, Message } from '@dbk/ui-forms';
import { Visible, Hide, Info2} from '@dbk/ui-icons';
import { ValidationLabelPassword } from '../../../components/common/validation/index.js';
import { ERGON_CHANGE_PASSWORD_TYPE, PALETTE  } from '../../../constants.js';
import { testIDProps } from '../../../common/components/utils/with-automation-id-props.js';
import  PopOver  from '../../../components/popover-component/popover.js'
import Spinner from '@dbk/ui-spinner';
import getEncryptedPayload from '../../../utils/getEncryptedPayload.js';

const jose = require('node-jose');
const passwordMinimumChars = 8;

class ChangePasswordEcredentials extends PureComponent {
  constructor(props) {
    super(props);
    this.newPassCrypto = undefined;

    this.state = {
      isSecureTextEntry: true,
      password: '',
      newPassword: '',
      newPasswordEmptyText: '',
      passwordEmpty: false,
      confirmPassword: '',
      passwordErrorText: '',
      confirmPasswordError: undefined,
      noMinimumChars: undefined,
      noUpperCase: undefined,
      noLowerCase: undefined,
      noSpecialChars: undefined,
      noSamePassword: undefined,
      noNumerical:undefined,
      minimumChars: false,
      upperCase: false,
      lowerCase: false,
      specialChars: false,
      numericCase:false,
      invalidChar:false,
      invalidCharConfirm:false,
      minimumCharsConfirm: false,
      upperCaseConfirm: false,
      lowerCaseConfirm: false,
      specialCharsConfirm: false,
      numericCaseConfirm: false,
      noPassword: false,
      activeTextBox: "",
      selection: { start: 0, end: 0 },
      userId: undefined,
      showNewPwdHideIcon: false,
      showOldPwdHideIcon: false,
      showConfirmPwdHideIcon: false,
      passwordEmpty: undefined,
      encryptedPwd: null,
      encryptedNewPwd: null
    };

    // Submit
    this.handleChangePassword = this.handleChangePassword.bind(this);

    // Input value change
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this);
    this.handleConfirmPasswordChange = this.handleConfirmPasswordChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    // Show or hide password values
    this.togglePasswordValue = this.togglePasswordValue.bind(this);

    this.doChangePassword = this.doChangePassword.bind(this);
    this.validateOnboarding = this.validateOnboarding.bind(this);
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.password.cryptoEncryptedObjSuccess !== this.props.password.cryptoEncryptedObjSuccess) {
        this.encryptedPwdForAuthentication();
    }
    if (prevProps.password.authenticateResponse !== this.props.password.authenticateResponse) {
        this.getNewEncryptedPassword()
    }
    if(prevState.encryptedPwd != this.state.encryptedPwd || prevState.encryptedNewPwd != this.state.encryptedNewPwd){
        this.sendEncryptedPwdForUpdation();
    }
  }

 

  sendEncryptedPwdForUpdation = () => {
    const { encryptedPwd, encryptedNewPwd } = this.state;
    if(encryptedPwd && encryptedNewPwd) {
      const { token } = this.props.password.cryptoEncryptedObj;
      const seskey = this.props.password.sessionId; 
      this.props.auth.onUpdatePassword({
        seskey: seskey,
        e2eOldPassword: encryptedPwd,
        e2eNewPassword: encryptedNewPwd,
        token: token,
        changePasswordType: ERGON_CHANGE_PASSWORD_TYPE.MANDATORY_CHANGE_PASSWORD
      })
    }
  }

  getSamePasswordText({ newPasswordEmpty, noSamePassword }) {
    const { i18n: { messages } } = this.props;

    if (newPasswordEmpty) {
      return {
        error: true,
        text: messages['app.auth.newPassword.errorText'],
      };
    }

    if (noSamePassword) {
      return {
        error: true,
        text: messages['app.auth.validation.noSamePassword'],
      };
    }

    return {
      error: noSamePassword === false ? false : newPasswordEmpty,
      text: '',
    };
  }

  getPasswordErrorText({ confirmPasswordEmpty, noMatch }) {
    const { i18n: { messages } } = this.props;

    if (confirmPasswordEmpty) {
      return {
        error: true,
        text: messages['app.auth.confirmPassword.errorText'],
      };
    }

    if (noMatch) {
      return {
        error: true,
        text: messages['app.auth.noMatchPassword.errorText'],
      };
    }

    return {
      error: noMatch === false ? false : confirmPasswordEmpty,
      text: '',
    };
  }

  onShowHideOldIcon = (value) => {
    this.setState({ showOldPwdHideIcon: value})
  }
  onShowHideNewIcon = (value) => {
    this.setState({ showNewPwdHideIcon: value})
  }
  onShowHideConfirmIcon = (value) => {
      this.setState({ showConfirmPwdHideIcon: value})
  }

  validateOnboarding(){ // WMCE-36536-introducing onboarding change password validations aliong with settings change password
    const {  newPassword, confirmPassword , password } = this.state;
    let noSamePassword , passwordEmpty;
    noSamePassword = equalPassword(password, newPassword);
    passwordEmpty = emptyError(password, false);
    const noMatch = noMatchError(newPassword, confirmPassword);
    const passwordError = this.getPasswordErrorText({
     noMatch,
    });
    const samePassword = this.getSamePasswordText({
     noSamePassword,
    });
    this.setState({
    confirmPasswordError: passwordError.error,
    passwordErrorText: passwordError.text,
    newPasswordEmpty: samePassword.error,
    newPasswordEmptyText: samePassword.text,
    passwordEmpty : passwordEmpty,
    showOldPwdHideIcon: false,
    showNewPwdHideIcon: false,
    showConfirmPwdHideIcon: false,
    });
    const valid= !noMatch && !noSamePassword && ! passwordEmpty 
    return(valid);
   }

   togglePasswordValue() {
    this.setState({
      isSecureTextEntry: !this.state.isSecureTextEntry,
    });
  }

  isUpperCase(value){
    return /[A-ZÖÄÜ]/.test(value) ;
  }

  isLowerCase(value){
  return /[a-zßöäü]/.test(value);
  }

  isSpecialChar(value){
    return /[!`~@#$%^&*()_+\-\[\]{};':"|.<>\/?]/.test(value);
  }

  isNumericCase(value){
    return /[0-9]/.test(value) ;
  }

  isInvalidChar(value){
    return value ? (/[^!`~@#$%^&*()_+\-\[\]{};':"|.<>\/?0-9A-ZÖÄÜa-zßöäü]/.test(value)) : false;
  }

  isMinLen(value){
    return (value.length>=8);
  }

  handlePasswordChange(ev) {
    const { target: { value } } = ev;
    this.setState({ password: value });
    this.props.auth.setErrorMsg("");
    this.onPasswordError();
  }

  handleNewPasswordChange(ev) {      //WMCE-36536- for displaying successtick icon on every validation
    const { target: { value } } = ev;
    this.setState({ newPassword: value });
    this.setState({upperCase : this.isUpperCase(value)});
    this.setState({lowerCase : this.isLowerCase(value)});
    this.setState({specialChars : this.isSpecialChar(value)});
    this.setState({numericCase : this.isNumericCase(value)});
    this.setState({minimumChars : this.isMinLen(value)});
    this.setState({invalidChar : this.isInvalidChar(value)});
    this.props.auth.setErrorMsg("");
    this.onError();
  }

  handleConfirmPasswordChange(ev) {
    const { target: { value } } = ev;
    this.setState({ confirmPassword: value });
    this.setState({upperCaseConfirm : this.isUpperCase(value)});
    this.setState({lowerCaseConfirm : this.isLowerCase(value)});
    this.setState({specialCharsConfirm : this.isSpecialChar(value)});
    this.setState({numericCaseConfirm : this.isNumericCase(value)});
    this.setState({minimumCharsConfirm :this.isMinLen(value)});
    this.setState({invalidCharConfirm :this.isInvalidChar(value)});
    this.props.auth.setErrorMsg("");
    this.onError();
  }

  isConfirmPasswordValid=()=>{  //WMCE-36536-for enabling and disabling change password button
    const {upperCaseConfirm, lowerCaseConfirm, numericCaseConfirm, minimumCharsConfirm, invalidCharConfirm, invalidChar, specialCharsConfirm,upperCase, lowerCase, numericCase,minimumChars,specialChars,confirmPasswordError , newPasswordEmpty ,passwordEmpty} = this.state;
    return upperCaseConfirm && lowerCaseConfirm && numericCaseConfirm && !invalidCharConfirm && !invalidChar && minimumCharsConfirm && specialCharsConfirm && upperCase && lowerCase && numericCase && minimumChars && specialChars  && (!confirmPasswordError && !newPasswordEmpty && !passwordEmpty)
  }

  onError=()=>{     //WMCE-36536-To remove error message if user starts updating the passwords
    const {confirmPasswordError , newPasswordEmpty } = this.state; 
     if (confirmPasswordError || newPasswordEmpty  ){
     this.setState({confirmPasswordError :false , newPasswordEmpty:false })
   }
  }

  onPasswordError = async()=>{
    const { passwordEmpty } = this.state;
    if(passwordEmpty ){
    await this.setState({passwordEmpty: emptyError(this.state.password,false)})
  }
  }

  handleSubmit(value) {
    if (value === 'Enter') {
      this.handleChangePassword();
    }
  }

  handleChangePassword() {
    const { app: { config: { isAirLockUpgrade } }, auth: { eCredPwd, e2eCryptoObj } } = this.props;
    const userId = this.props.auth.userId;
    const confirmValidate=this.validateOnboarding();
    if (confirmValidate) {
      this.props.auth.setChangePasswordBusy(true);
      let type = 'login';
      this.props.password.getEncryptionToken({ userId, type });
    }
    else if(document.querySelector('.password-error')){ 
      document.querySelector('.password-error').focus();
    }
  }

  encryptedPwdForAuthentication = () => {
    const { password, newPassword } = this.state;
    const userId = this.props.auth.userId;
    const { token, modulus, exponent, seskey, keyType } = this.props.password.cryptoEncryptedObj;

    const payloadForPwdEncryption = getEncryptedPayload({
        password: password
      });

    const publicKey = {
      'kty': keyType,
      'alg': 'RSA-OAEP-256',
      'enc': 'A128GCM',
      'n': modulus,
      'e': exponent,
    };

    jose.JWK.asKey(publicKey).
      then((result) => {

        jose.JWE.createEncrypt({ format: 'compact', contentAlg: 'A128GCM' , fields: { nonce: token }}, result.toJSON()).
          update(jose.util.asBuffer(JSON.stringify(payloadForPwdEncryption))).
          final().
          then((jwe) => {
            const data = jwe.replace(/\./g, '*');
            // give call to /authenticate
             const { randnr, pubkey } = this.props.password.cryptoEncryptedObj;
        this.props.password.globalAuthLogin({
            userId,
            password,
            data,
            token,
            randnr,
            pubkey,
            seskey
        });
            
          }).catch((err) => {
            if (err) {
              this.props.auth.setChangePasswordBusy(false);
              this.props.auth.setErrorMsg(
                'Unable to connect. Please try again later.'
              );
            }
          });
      });
  }

getNewEncryptedPassword = () => {
    const { auth: { e2eCryptoObj } } = this.props;
    const { password, newPassword } = this.state;
    const userId = this.props.auth.userId;
    const { modulus, exponent, keyType, token } = e2eCryptoObj; // using new crypto obj, encrypt old and new pwd separately

    const payloadForPwdEncryption = getEncryptedPayload({
      password: password
    });
    const payloadForNewPwdEncryption = getEncryptedPayload({
      password: newPassword
    });

    const publicKey = {
      'kty': keyType,
      'alg': 'RSA-OAEP-256',
      'enc': 'A128GCM',
      'n': modulus,
      'e': exponent,
    };
    jose.JWK.asKey(publicKey).
      then((result) => {
        jose.JWE.createEncrypt({ format: 'compact', contentAlg: 'A128GCM', fields: { nonce: token } }, result.toJSON()).
          update(jose.util.asBuffer(JSON.stringify(payloadForPwdEncryption))).
          final().
          then((jwe) => {
            const data = jwe.replace(/\./g, '*');
            this.setState({encryptedPwd: data});
          }).catch((err) => {
            if (err) {
              this.props.auth.setChangePasswordBusy(false);
              this.props.auth.setErrorMsg(
                'Unable to connect. Please try again later.'
              );
            }
          });
      });

      jose.JWK.asKey(publicKey).
      then((result) => {
        jose.JWE.createEncrypt({ format: 'compact', contentAlg: 'A128GCM', fields: { nonce: token } }, result.toJSON()).
          update(jose.util.asBuffer(JSON.stringify(payloadForNewPwdEncryption))).
          final().
          then((jwe) => {
            const data = jwe.replace(/\./g, '*');
            this.setState({encryptedNewPwd: data});
          }).catch((err) => {
            if (err) {
              this.props.auth.setChangePasswordBusy(false);
              this.props.auth.setErrorMsg(
                'Unable to connect. Please try again later.'
              );
            }
          });
      });
  }

  doChangePassword() {
    const { password, newPassword } = this.state;
    let globalAuth = this.props.auth;
    const {
      token,
      modulus,
      exponent,
      randnr,
      pubkey,
      seskey,
    } = globalAuth.cryptoEncryptedObj;
    let cryptoEncryptionRequestParamNewPWD = {
      password: newPassword,
      modulus: modulus,
      exponent: exponent,
      token: token,
    };
    let cryptoEncryptionRequestParamOldPWD = {
      password: password,
      modulus: modulus,
      exponent: exponent,
      token: token,
    };
    let promiseNewEncryption = encryptionHtmlAndScript(
      JSON.stringify(cryptoEncryptionRequestParamNewPWD)
    );
    let promiseOldEncryption = encryptionHtmlAndScript(
      JSON.stringify(cryptoEncryptionRequestParamOldPWD)
    );
    promiseNewEncryption.then((newCrypto) => {
      promiseOldEncryption.then((oldCrypto) => {
        globalAuth.onChangePassword({
          password: password,
          newPassword: newPassword,
          oldCryptoPassword: oldCrypto,
          newCryptoPassword: newCrypto,
          token: token,
          randnr: randnr,
          pubkey: pubkey,
          seskey: seskey,
        });
    });
   });
  }

  render() {
    const {
      password,
      newPassword,
      newPasswordEmptyText,
      confirmPassword,
      passwordEmpty,
      newPasswordEmpty,
      confirmPasswordError,
      noUpperCase,
      nolowerCase,
      noMinimumChars,
      noSpecialChars,
      noNumerical,
      passwordErrorText,
      isSecureTextEntry,
      minimumChars,
      upperCase,
      lowerCase,
      numericCase,
      invalidChar,
      invalidCharConfirm,
      specialChars,
    } = this.state;

    const { i18n: { messages }, auth, forgotPassword: { generateTempPwdResultValid } } = this.props;
    const title = generateTempPwdResultValid ? messages['app.reset.forgotPassword.createPwd'] : messages['app.common.pageTitle.changePass'];
    const secureTextEntryText = isSecureTextEntry
      ? messages['app.auth.showPassword']
      : messages['app.auth.hidePassword'];

    return (
      <div>
        <div className="change-password">
          <div className="row small-12 large-6">
            <div className="change-password-container">
              <div className="module changePasswordAlign">
                {/* commenting since we dont required this messages */}
               {/* <InfoMessage messages={messages} />  */}
               <div tabIndex={0} className="change-password__title">
                  <H3>{title}</H3>
                </div>
                <div className='change-password-input-field'>
                  <FormGroup style={{marginBottom:15}} className="new-pass-2">
                    <div className='input-bottom-margin'>
                      <View {...testIDProps("lbl_old_password_login_test")}>    
                        <Label {...testIDProps("label_change_login_password_old_password_test")} style={styles.labelStyleCH}>{messages['app.auth.password']}</Label>
                      </View>
                      <div className='padding-bottom'></div> 
                      <TextInput
                        size="large"
                        value={password}
                        type={!this.state.showOldPwdHideIcon ? "password" : "text"}
                        onChange={this.handlePasswordChange}
                        onKeyPress={this.handleSubmit}
                        aria-label={messages['app.auth.password']}
                        error={passwordEmpty || (auth.changePasswordError && !auth.passwordUsedError)}
                        iconRight={this.state.showOldPwdHideIcon ? <TouchableOpacity id="icon_old_password_login_test"
                        accessibilityLabel={messages['app.accessibility.forgotPwd.setNewpwd']}
                          {...testIDProps("tooltip_old_password_login_test")}
                          onPress={() => this.onShowHideOldIcon(false)}
                          >
                          <Visible className="visible-icon" color={PALETTE.primaryText} />
                        </TouchableOpacity> :
                        <TouchableOpacity id="icon_old_password_login_test"
                          {...testIDProps("tooltip_old_password_login_test")}
                          accessibilityLabel={messages['app.accessibility.forgotPwd.setNewpwd']}
                          onPress={() =>this.onShowHideOldIcon(true)}
                          >
                          <Hide width={22} height={22} color={PALETTE.primaryText}/>
                        </TouchableOpacity> }
                      />
                    </div>
                  </FormGroup>
                  <FormGroup style={styles.marginBottom} className="new-pass-2">
                    <View {...testIDProps("lbl_loginPage_password_login_test")}>    
                      <Label {...testIDProps("label_change_login_password_new_password_test")} style={styles.labelStyleCH} >{messages['app.auth.newPassword']}</Label>
                    </View>
                    <div className='padding-bottom'></div>   
                    <div className='input-bottom-margin'>
                      <TextInput
                        size="large"
                        value={newPassword}
                        type={!this.state.showNewPwdHideIcon  ? "password" : "text"}
                        onChange={this.handleNewPasswordChange}
                        onKeyPress={this.handleSubmit}
                        aria-label={messages['app.auth.newPassword']}
                        error={newPasswordEmpty || confirmPasswordError || (auth.passwordUsedError && auth.changePasswordError)}
                        iconRight = {this.state.showNewPwdHideIcon ? <TouchableOpacity id="icon_new_password_login_test"
                          {...testIDProps("tooltip_new_password_login_test")}
                          accessibilityLabel={messages['app.accessibility.forgotPwd.setNewpwd']}
                          onPress={() => this.onShowHideNewIcon(false)}
                          >
                          <Visible className="visible-icon" color={PALETTE.primaryText} />
                        </TouchableOpacity> :
                        <TouchableOpacity id="icon_new_password_login_test"
                          {...testIDProps("tooltip_new_password_login_test")}
                          accessibilityLabel={messages['app.accessibility.forgotPwd.setNewpwd']}
                          onPress={() =>this.onShowHideNewIcon(true)}
                          >
                          <Hide width={22} height={22} color={PALETTE.primaryText}/>
                        </TouchableOpacity> }
                      />
                    </div>
                  </FormGroup>
                  {invalidChar &&
                    <div tabIndex={0}>
                      <Message style={styles.passwordError} type="error">
                        {messages['app.auth.validation.invalid.character']}
                      </Message>
                    </div>}
                  <FormGroup className="new-pass-3">
                    <View {...testIDProps("lbl_change_password_login_test")} tabIndex={0}>    
                      <Label {...testIDProps("label_change_password_confirm_new_password_test")} style={styles.labelStyleCH}>{messages['app.auth.confirmPassword.header']}</Label>
                    </View>
                    <div className='padding-bottom'></div> 
                    <div className='input-bottom-margin'>
                      <TextInput
                        size="large"
                        value={confirmPassword}
                        type={!this.state.showConfirmPwdHideIcon ? "password" : "text"}
                        onChange={this.handleConfirmPasswordChange}
                        onKeyPress={this.handleSubmit}
                        aria-label={messages['app.auth.confirmPassword.header']}
                        error={newPasswordEmpty || confirmPasswordError}
                        iconRight = {this.state.showConfirmPwdHideIcon? <TouchableOpacity id="icon_confirm_password_login_test"
                          {...testIDProps("tooltip_confirm_password_login_test")}
                          accessibilityLabel={messages['app.accessibility.forgotPwd.setNewpwd']}
                          onPress={() => this.onShowHideConfirmIcon(false)}
                          >
                          <Visible className="visible-icon" color={PALETTE.primaryText} />
                        </TouchableOpacity> :
                        <TouchableOpacity id="icon_confirm_password_login_test"
                          {...testIDProps("tooltip_confirm_password_login_test")}
                          accessibilityLabel={messages['app.accessibility.forgotPwd.setNewpwd']}
                          onPress={() =>this.onShowHideConfirmIcon(true)}
                          >
                          <Hide width={22} height={22} color={PALETTE.primaryText}/>
                        </TouchableOpacity> }
                      />
                    </div>
                  </FormGroup>
                  {invalidCharConfirm &&
                  <div tabIndex={0}>
                   <Message style={styles.passwordError} type="error">
                     {messages['app.auth.validation.invalid.character']}
                   </Message>
                   </div>} 
                   <div tabIndex={0} className="password-error">
                  {passwordEmpty? (
                    <Message {...testIDProps("lbl_settings_errorPassword_test")} style={styles.passwordError} type="error">
                      {messages['app.auth.password.errorText']}
                    </Message>)
                    :
                    (auth.changePasswordError && !auth.passwordUsedError) ? (
                      <Message style={styles.passwordError} type="error">
                        {auth.changePasswordErrorMessage}
                      </Message>) 
                    :
                    (auth.changePasswordError && auth.passwordUsedError) && (
                      <Message style={styles.passwordError} type="error">
                        {auth.changePasswordErrorMessage}
                      </Message>)}
                  { (confirmPasswordError && !newPasswordEmpty ) &&(
                    <Message style={styles.passwordError} type="error">
                      {passwordErrorText}
                    </Message>)}
                  {newPasswordEmpty && (
                  <Message style={styles.passwordError} type="error">
                    { newPasswordEmptyText}
                  </Message>)}
                  </div>
                </div>
                  <View style={styles.validationLabels}>
                  <div tabIndex={0}>
                    <DBKText size="large" className="label-style">{messages['app.auth.validation.newPasswordContains']}</DBKText>
                  </div>
                  <div tabIndex={0}>
                    <ValidationLabelPassword
                      style={styles.validationLabel}
                      title={messages['app.auth.validation.minimumChars']}
                      error={noMinimumChars}
                      showTick={minimumChars}
                    />
                    </div>
                     <div tabIndex={0}>
                    <ValidationLabelPassword
                      style={styles.validationLabel}
                      title={messages['app.auth.validation.upperCase']}
                      error={noUpperCase}
                      showTick={upperCase}
                    />
                    </div>
                    <div tabIndex={0} aria-label={messages['app.auth.validation.lowerCase']}>
                    <ValidationLabelPassword
                      style={styles.validationLabel}
                      title={messages['app.auth.validation.lowerCase']}
                      error={nolowerCase}
                      showTick={lowerCase}
                    />
                    </div>
                    <div className='specialCharContainer'>
                      <div tabIndex={0} className='specialCharContainer' aria-label={messages["app.auth.validation.specialChars"]}>
                     <ValidationLabelPassword
                       style={styles.validationLabel}
                       title={messages['app.auth.validation.specialChars']}
                       error={noSpecialChars}
                       showTick={specialChars}
                     />
                     </div>
                    
                     <PopOver
                      mode="popup"
                      orientation="top"
                      showOnHover
                      popOverClassName="special-char-popover"
                      arrowColor={PALETTE.secondaryActive}
                      content={<div>{messages["app.auth.validation.special.chars.popover"]}</div>}
                    >
                      <div aria-label={messages["app.auth.specialCharPopoverLabel"]} className='specialCharContainer'>
                        <Info2 color={PALETTE.fordGray} height={29} width={29}/> 
                       </div>  
                     </PopOver>
                     </div>
                     <div tabIndex={0}>
                    <ValidationLabelPassword
                      style={styles.validationLabel}
                      title={messages['app.auth.validation.number']}
                      error={noNumerical}
                      showTick={numericCase}
                      />
                       </div>
                  </View>
                  {
                    ( this.isConfirmPasswordValid()
                      ?               //WMCE-36536-Using TouchableOpacity to resolve the issue of after disabling of ButtonDBK when it gets enabled UI is still of disabled state though the button gets enabled for further task
                      <div className={generateTempPwdResultValid ? '': 'btn-change-password-container'}>
                        <div className={generateTempPwdResultValid ? '': 'btn-width'}>
                          <TouchableOpacity
                            accessibilityComponentType="button"
                            accessibilityTraits="button"
                            accessibilityRole="button"
                            onPress={() =>this.handleChangePassword()}
                            style={ styles.touchableOpacityEnabled}>
                            <View style={styles.buttonDirection}>
                            <Text style={styles.textEnabled}>
                              {messages['app.changePassword.changePasswordText']}
                            </Text>
                            {auth.changePasswordBusy === true && <View className="margin-left-5">
                              <Spinner
                                size="medium"
                                stroke={1}
                                inner
                                velocity={12}
                              /></View>}
                            </View>
                          </TouchableOpacity>
                        </div>
                      </div>
                    :
                    <div className={generateTempPwdResultValid ? '': 'btn-change-password-container'}>
                        <div className={generateTempPwdResultValid ? '' : 'btn-width'}>
                          <TouchableOpacity
                            accessibilityComponentType="button"
                            accessibilityTraits="button"
                            accessibilityRole="button"
                            disabled={true}
                            onPress={() =>this.handleChangePassword()}
                            style={styles.touchableOpacityDisabled}>
                            <Text style={styles.textDisabled}>
                              {messages['app.changePassword.changePasswordText']}
                            </Text>
                          </TouchableOpacity>
                        </div>
                      </div>
                    )
                  }
                  {/* {auth.changePasswordBusy === true && <LoadingCircle />} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    auth: {
      onChangePassword: { $call: 'globalAuthChangePassword' },
      changePasswordErrorMessage: true,
      changePasswordBusy: true,
      cryptoEncryptedObj: true,
      globalAuthEncryptionKey: { $call: 'getGlobalAuthEncryptionKey' },
      cryptoEncryptedObjSuccess: true,
      setCryptoEncryptedObjSuccess: { $set: 'cryptoEncryptedObjSuccess' },
      userId: true,
      setChangePasswordBusy: { $set: 'changePasswordBusy' },
      setErrorMsg: { $set: 'changePasswordErrorMessage' },
      changePasswordError:true,
      passwordUsedError: true,
      resetInfoMessage: { $call: 'resetInfoMessage' },
      eCredPwd: true,
      e2eCryptoObj: true,
      onUpdatePassword: { $call: 'updatePassword' }
    },
    i18n: {
      messages: true,
    },
    forgotPassword: {
      generateTempPwdResultValid: true
    },
    app: {
      config: {
        isAirLockUpgrade: true
      }
    },
    password: {
        cryptoEncryptedObj: true,
        getEncryptionToken: { $call: 'getEncryptionToken' },
        cryptoEncryptedObjSuccess: true,
        setCryptoEncryptedObjSuccess: { $set: 'cryptoEncryptedObjSuccess' },
        globalAuthLogin: { $call: 'globalauthlogin' },
        authenticateResponse: true,
        sessionId: true
    }
  },
})(ChangePasswordEcredentials);
